import React, { FC } from 'react';
import { InsertLink } from '@mui/icons-material';
import { MenuButton, useRichTextEditorContext } from 'mui-tiptap';
import { getSelectedText } from '../../tiptapHelper';
import { useGuideCmsContext } from '../../../GuideCmsContext';

export const AddInternalLinkToolbarButton: FC = () => {
  const { openInternalLinksDialog } = useGuideCmsContext();
  const editor = useRichTextEditorContext();
  const handleOnClick = async () => {
    if (!editor) return;
    await openInternalLinksDialog(getSelectedText(editor));
  };
  if (!editor) return null;
  return <MenuButton disabled={!editor?.isEditable} IconComponent={InsertLink} tooltipLabel="Intern lenke" onClick={handleOnClick}></MenuButton>;
};
